export const loadSpeechStreamScript = () => {
  return new Promise(resolve => {
    if (window.speechstream) {
      resolve(window.speechstream);
      return;
    }

    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://toolbar.speechstream.net/SpeechStream/latest/speechstream.js';
    script.setAttribute('data-speechstream-config', 'MyInfinitecR1');
    script.onload = () => resolve(window.speechstream);
    document.body.appendChild(script);

    // Wait for script if needed
    const check = setInterval(() => {
      if (window.speechstream) {
        clearInterval(check);
        resolve();
      }
    }, 100);
  });
};

export const loadSpeechStreamToolbar = async () => {
  // Wait for script to be defined
  if (!window.speechstream) {
    await new Promise(resolve => {
      const check = setInterval(() => {
        if (window.speechstream) {
          clearInterval(check);
          resolve();
        }
      }, 100);
    });
  }

  try {
    await window.speechstream.Loader.lateLoad();

    return true;
  } catch (err) {
    console.error('Error loading SpeechStream toolbar:', err);
    return false;
  }
};

export const speechStreamAddCommand = (id, command) => {
  if (!window?.speechstream?.domControlTools) {
    return false;
  }

  try {
    const doc = window.document;
    if (!doc) {
      return false;
    }

    const domControl = window.speechstream.domControlTools.getNewDomControl(doc);
    domControl.addCommand(id, command);

    return true;
  } catch (error) {
    return false;
  }
};

export const isSpeechStreamToolbarActive = () => {
  return typeof window?.speechstream?.isToolbarActive === 'function' && window.speechstream.isToolbarActive();
};

export const setSpeechCompleteCallback = () => {
  return window?.speechstream?.speechTools?.setSpeechCompleteCallback || null;
};

export const isSpeechStreamLoaded = async () => {
  return window?.speechstream?.Loader === undefined;
};

export const speechStreamToggleBar = async () => {
  if (!(await isSpeechStreamLoaded())) return;

  return new Promise(async resolve => {
    // First call toggles the bar and triggers initialization
    await window.speechstream.toggleBar();

    // Wait for any internal initialization to complete
    const checkInitialization = () => {
      if (window.speechstream.settings && window.speechstream.domControlTools) {
        resolve();
      } else {
        setTimeout(checkInitialization, 50);
      }
    };

    checkInitialization();
  });
};
